import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { SitePage } from "@tih/shared";
import { adminDeletePage, adminFetchPages } from "../../api/client";

export function AdminContentPage() {
  const [rows, setRows] = useState<SitePage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      setRows(await adminFetchPages());
    } catch (e) {
      setError(String((e as Error).message ?? e));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  async function remove(id: number, title: string) {
    if (!confirm(`Delete "${title}"? This cannot be undone.`)) return;
    await adminDeletePage(id);
    await load();
  }

  return (
    <div className="admin-page">
      <header className="admin-page-header admin-page-header-row">
        <div>
          <h1>Pages</h1>
          <p>
            {rows.length} pages total. Static pages use the block editor — like WordPress Pages vs Blog posts.{" "}
            <Link to="/admin/content/json?key=event">Advanced JSON</Link>
          </p>
        </div>
        <Link to="/admin/content/new" className="btn btn-primary">New page</Link>
      </header>
      {error && <div className="form-error">{error}</div>}
      {loading ? (
        <div style={{ opacity: 0.5 }}>Loading…</div>
      ) : rows.length === 0 ? (
        <div style={{ opacity: 0.6 }}>No pages yet. Create one to publish content at <code>/pages/your-slug</code>.</div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id}>
                  <td>{p.title}</td>
                  <td><code>{p.slug}</code></td>
                  <td>
                    <span className={`status-pill status-${p.status.toLowerCase()}`}>{p.status}</span>
                  </td>
                  <td>{new Date(p.updatedAt).toLocaleString()}</td>
                  <td className="admin-row-actions">
                    <Link to={`/admin/content/${p.id}`} className="btn btn-ghost">Edit</Link>
                    {p.status === "PUBLISHED" && (
                      <Link to={`/pages/${p.slug}`} className="btn btn-ghost">View</Link>
                    )}
                    <button type="button" className="btn btn-danger" onClick={() => remove(p.id, p.title)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
